import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { initialCandidateDetailsSlice } from './candidate-details.slice';
import { environment } from 'src/environments/environment';
import { CandidateDetails } from '../../models/candidate-details.model';

export const CandidateDetailsStore = signalStore(
    { providedIn: 'root' },

    withState(initialCandidateDetailsSlice),

    withComputed((store) => ({
        snapshot: computed(() => ({
            candidateId: store.candidateId(),
            candidateName: store.candidateName(),
            candidateEmail: store.candidateEmail(),
            candidateNPI: store.candidateNPI(),
            professionId: store.professionId(),
            professionName: store.professionName(),
            specialties: store.specialties(),
            professionExpertises: store.professionExpertises(),
            candidateExpertiseId: store.candidateExpertiseId(),
            expertiseId: store.expertiseId(),
            expertiseYearsOfExperience: store.expertiseYearsOfExperience(),
            providerProfile: store.providerProfile(),
            recruiterId: store.recruiterId(),
            recruiterName: store.recruiterName()
        }))
    })),

    withMethods((store) => ({
        updateCandidateDetailsFromData: (data: Partial<CandidateDetails>) => {
            patchState(store, { ...data });
        },

        getState: () => store,

        getSnapshot: () => store.snapshot()
    })),

    environment.storeWithDevTools('locums-margin-calculator-candidate-details-store')
);
